import React from 'react';
import ReactDOM from 'react-dom';
import RenderHeader from 'ViewModels/Components/RenderHeader';

import EventsContainer from 'ViewModels/Components/Events/EventsContainer';

const MainContainer = () => {
    return (<EventsContainer resources={window.jenkon.resources} />);
};

ReactDOM.render(<MainContainer />, document.getElementById('main-content'));



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Events.js